module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_kungalv-fe30bd601230ce8343d840b6c310a487.png";